module.exports = __webpack_public_path__ + "img/Icon-metro-file-video.ded67498.svg";